import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid } from '@material-ui/core';

const OneSkeleton = () => (
	<div
		style={{
			width: '100%',
			margin: '10px',
		}}
	>
		<Skeleton variant='text' />
		<Skeleton variant='circle' width={40} height={40} />
		<Skeleton variant='rect' height={118} />
	</div>
);

export default function BaseSkeleton() {
	return (
		<Grid container spacing={3}>
			<Grid item key={1} lg={3} md={4} xs={6}>
				<OneSkeleton />
			</Grid>
			<Grid item key={2} lg={3} md={4} xs={6}>
				<OneSkeleton />
			</Grid>
			<Grid item key={3} lg={3} md={4} xs={6}>
				<OneSkeleton />
			</Grid>
			<Grid item key={4} lg={3} md={4} xs={6}>
				<OneSkeleton />
			</Grid>
		</Grid>
	);
}
